import React, { memo } from 'react';
import { asColor } from '@atlassian/jira-issue-epic-color/src/common/utils.tsx';
import { useFieldValue } from '@atlassian/jira-issue-field-base/src/services/field-value-service/index.tsx';
import { SUMMARY_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { useBacklogSelector } from '../../../../../state/index.tsx';
import { getCardEpicColor } from '../../../../../state/selectors/cards/index.tsx';
import { getEpicColorFieldId } from '../../../../../state/selectors/config/index.tsx';
import ParentFieldStatic from '../parent-field/parent-field-static/index.tsx';

export type EpicLozengeFieldProps = {
	issueId: number;
	issueKey: string;
	isCompactView: boolean;
};

const EpicLozengeField = ({ issueKey, issueId, isCompactView }: EpicLozengeFieldProps) => {
	const epicColorFieldId = useBacklogSelector(getEpicColorFieldId);
	const cardColor = useBacklogSelector((state) => getCardEpicColor(state, issueId));

	const [epicColorFromFieldsStore] = useFieldValue({
		issueKey,
		fieldKey: epicColorFieldId ?? '',
	});

	const [epicSummary] = useFieldValue({
		issueKey,
		fieldKey: SUMMARY_TYPE,
	});

	const color = asColor(epicColorFromFieldsStore || cardColor);
	return epicSummary ? (
		<ParentFieldStatic color={asColor(color)} summary={epicSummary} isCompactView={isCompactView} />
	) : null;
};

export default memo<EpicLozengeFieldProps>(EpicLozengeField);
